import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { CoreTranslationService } from "@core/services/translation.service";
import { AuthenticationService, UserService } from "app/auth/service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

import { locale as en } from "../i18n/en";
import { locale as fr } from "../i18n/fr";

import { PaymentCard } from "../account.module";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-account",
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AccountComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any>;
  private _currentUser: any;

  public editUserDetails: FormGroup;

  // public repositories: Object = {
  //   1: "ANSSI",
  //   2: "ISO 27001",
  //   3: "CMMC",
  //   4: "AirCyber",
  //   5: "PCI-DSS",
  //   6: "PGSSI-S",
  // };

  public formErrors: Object = {
    nbErrors: 0,
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    repository: null,
    function: null,
  };

  public paymentCards: PaymentCard[] = [
    {
      owner: "Tom McBride",
      brand: "mastercard",
      isPrimary: true,
      cardNumber: "**** **** 9865",
      expirationDate: "12/24",
      id: 1,
    },
    {
      owner: "Tom McBride",
      brand: "visa",
      isPrimary: true,
      cardNumber: "**** **** 9865",
      expirationDate: "12/24",
      id: 2,
    },
  ];

  // public
  public contentHeader: object;

  public user: any;

  public userIsPremium: boolean = false;

  public modalLoadingButton: boolean = false;

  public loading: boolean = true;

  public showUserModal: boolean = false;
  public fadeoutUserModal: boolean = false;

  
  public showPricingPlansModal: boolean = false;
  public fadeoutPricingPlansModal: boolean = false;

  public activeId: any = 1;

  public planBenefits: string[] = [
    "100 responses a month",
    "Unlimited forms and surveys",
    "Unlimited fields",
    "Basic form creation tools",
    "Up to 2 subdomains",
  ];

  /**
   * Constructor
   *
   * @param {CoreTranslationService} _coreTranslationService
   * @param {AuthenticationService} _authenticationService
   * @param {UserService} _userService
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    private _authenticationService: AuthenticationService,
    private _userService: UserService,
    private _router: Router,
    private _formBuilder: FormBuilder
  ) {
    this._authenticationService.currentUser.subscribe(
      (x) => (this._currentUser = x)
    );

    this._coreTranslationService.translate(en, fr);

    this._unsubscribeAll = new Subject();
  }

  get newPasswordInputs() {
    return this.editUserDetails.controls;
  }

  public toggleUserModal(): void {
    if (this.showUserModal) {
      this.fadeoutUserModal = true;
      setTimeout(() => {
        this.showUserModal = false;
        this.fadeoutUserModal = false;
      }, 300);
    } else {
      this.showUserModal = true;
    }
  }

  public togglePricingPlansModal(): void {
    if (this.showPricingPlansModal) {
      this.fadeoutPricingPlansModal = true;
      setTimeout(() => {
        this.showPricingPlansModal = false;
        this.fadeoutPricingPlansModal = false;
      }, 300);
    } else {
      this.showPricingPlansModal = true;
    }
  }

  public updateUserDetails() {
    this.formErrors["nbErrors"] = 0;
    this.modalLoadingButton = true;
    Object.entries(this.editUserDetails.controls).forEach((control) => {
      if (control[1].status == "INVALID") {
        this.formErrors[control[0]] = true;
        this.formErrors["nbErrors"]++;
      } else {
        this.formErrors[control[0]] = null;
      }
    });

    this.editUserDetails.patchValue({
      repository: String(this.editUserDetails.value.repository),
    });

    this._userService.editUserDetails(this.editUserDetails.value).subscribe(
      (data) => {
        console.log(data);
        this.modalLoadingButton = false;
        this.toggleUserModal();
        this.getUserData();
      },
      (error) => {
        console.log(error);
        this.modalLoadingButton = false;
      }
    );
  }

  private getUserData() {
    this._userService
      .getCurrentUser()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (res) => {
          this.user = res.data;

          this.editUserDetails = this._formBuilder.group({
            first_name: [this.user.first_name, [Validators.required]],
            last_name: [this.user.last_name, [Validators.required]],
            email: [this.user.email, [Validators.required]],
            phone: [this.user.phone, [Validators.required]],
            repository: [this.user.repository, [Validators.required]],
            function: [this.user.function, [Validators.required]],
          });

          this.userIsPremium = this.checkIfPremium();
        },
        (err) => {
          console.error({ err });

          if (err.message == "err.error.error is undefined") {
            this._router.navigateByUrl("/authentication/logout");
          }
        },
        () => {
          this.loading = false;
        }
      );
  }

  private checkIfPremium() {
    // return this.user.premium
    return false;
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {
    this.editUserDetails = this._formBuilder.group({
      first_name: [null, [Validators.required]],
      last_name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required]],
      repository: [null, [Validators.required]],
      function: [null, [Validators.required]],
    });

    this.getUserData();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
